import axios from 'axios'; 
import utils from '../utils/utils.js'

// const baseURL = 'https://web-api.beny.com.au'
const baseURL = 'https://web-api.beny.com.au'

// 创建axios实例
let service = axios.create({
    timeout: 60000, // 请求超时时间
    responseType: 'json',
    headers: {
        "Content-Type": "application/json",
        "Accept-Language": "en-US"
    }
})

// 请求拦截
service.interceptors.request.use(     
    config => {        
        const token = window.sessionStorage.getItem("token");        
        token && (config.headers['socialBase-admin-token'] = token);        
        return config;    
    },    
    error => {        
        return Promise.error(error);    
})

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

const requestMethod = ['get', 'delete', 'post', 'put']

const $axios = {}

requestMethod.forEach(method => {
    $axios[method] = function(url, data = {}, cancelToken) {
        return new Promise((resolve, reject) => {
            if (method === 'get') {
                service[method](`${baseURL}${url}`, {cache: false})
                .then(response => {
                    packageRespon(response, resolve);
                }, err => {
                    packageError(err)
                })
                .catch((error) => {
                    reject(error)
                    packageCatch(error)
                })
            } else {
                service[method](baseURL + url, data, {cancelToken: cancelToken})
                .then(response => {
                    packageRespon(response, resolve);
                }, err => {
                    packageError(err, url)
                })
                .catch((error) => {
                    reject(error)
                    packageCatch(error)
                })
            }
        })
    }
})

function packageRespon(res, resolve) {
    if (res.status == 200) {
        resolve(res);
    } else {
        utils.alert('', res.data.message ,'error');
    }
}


function packageError(err, url) {
    if (err !== 'Operationcanceled' && err.message !== 'Operationcanceled') {
        if (err == 'Error: timeout of 60000ms exceeded') {
            utils.alert('', 'Unable to connect to the server.' ,'error');
        } else if (err == 'Error: Network Error' || err.message == 'Network Error'){
            utils.alert('', 'Unable to connect to the server.', 'error')
        } else {
            utils.alert('', err ,'error');
        }
    }
}


function packageCatch(err) {
    utils.alert('', err ,'error');
}


export default $axios


// WEBPACK FOOTER //
// ./src/api/axios.js